export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9558.f750be05.jpg";